import { Tab, Tabs } from "@mui/material"
import React from "react"

const AppTab = ({ tabValue, setTabValue, tabList, marginBottom = 20, indicatorColor }) => {
    return (
        <React.Fragment>
            <Tabs
                value={tabValue}
                onChange={(e, val) => (setTabValue(val))}
                aria-label="basic tabs example"
                style={{ marginBottom: marginBottom}}
                TabIndicatorProps={{ sx: { display: 'none' } }}
                sx={{
                    '& .MuiTabs-flexContainer': {
                        flexWrap: 'nowrap',
                        overflowX: 'auto',
                        paddingBottom: 1
                    }
                }}
            >
                {
                    tabList && tabList.map((tab) => (
                        <Tab
                            key={tab.value}
                            value={tab.value}
                            sx={{ paddingBottom: 1, borderBottom: tabValue === tab.value ? `2px solid ${indicatorColor || '#D13536'}` : '2px solid transparent', transition: 'border-bottom 0.5s ease' }}
                            label={
                                <div className="d-flex font-size-14" style={{ color: tabValue === tab.value ? '#D7114D' : '#A0A0A0', textTransform: 'none', fontWeight: 400 }}>
                                    {tab.label}
                                </div>
                            }
                        />
                    ))
                }
            </Tabs>
        </React.Fragment>
    )
}

export default AppTab;